(() => {
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-lnw-search-sort] select')) return;
    const form = event.target.closest('form');
    const url = new URL(window.location.href);
    for (const key of ['preview_theme_id', 'pb']) {
      if (!url.searchParams.has(key)) continue;
      let input = form.querySelector('input[name="' + key + '"]');
      if (!input) input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = url.searchParams.get(key);
      form.append(input);
    }
    form.requestSubmit();
  });
})();
